import { Component, OnInit, Input } from '@angular/core';
import { ProjectService } from '../../../api/services/project.services';
import { AuthService } from '../../../api/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { BomLine } from '../../../api/models/bom-line';
import { BomTableService } from '../../bom-table/bom-table.service';
import { BomTableRow } from '../../../api/models/bom-table-row';
import { MarketService } from '../../../api/services/market.service';
import { Router } from '@angular/router';
import { ProjectOrderInput } from '../../../api/models/project-summary';

@Component({
  selector: 'app-worksheet-result',
  templateUrl: './worksheet-result.component.html',
  styleUrls: ['./worksheet-result.component.scss'],
  providers: [BomTableService]
})
export class WorksheetResultComponent implements OnInit {

  @Input() projectId: string;
  @Input() worksheetId: string;
  selectedBomId: string;
  orderItems = [];
  orderItemsToShow = [];
  noRecords: string;
  showBomTable = false;
  bomData: BomLine[];
  bomItems: BomTableRow[] = [];
  skuDetailLoading = false;
  page = 1;
  pageSize = 5;
  accountNumber: string = '';

  loading: boolean;
  
  constructor(private projectService: ProjectService,
    private authService: AuthService,
    private toastr: ToastrService,
    private bomTableService: BomTableService,
    private marketService: MarketService,
    private router: Router) { }

  ngOnInit() {
    this.setLoading(true);
    if (this.projectId) {
      this.projectService.getMyOrders(this.projectId, this.authService.getUserId()).subscribe(orders => {
        this.orderItems = orders;
        if (this.getOrderItems()) {
          this.marketService.getMarket(this.orderItems[0].project.marketId).subscribe(market => {
              if (market) {
                this.accountNumber = market.accountNumber;
              }
              this.loadPage(1);
          },
          error => {
            this.noRecords = "Invalid Market";
            this.setLoading(false);
          });
        } else {
          this.noRecords = "No records found!";
          this.setLoading(false);
        }
      }, error => {
          this.noRecords = "No records found!";
          this.setLoading(false);
      });
    } else {
      this.noRecords = "No records found!";
      this.setLoading(false);
    }
  }

  loadPage(page) {    
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    this.orderItemsToShow =  this.orderItems.slice(from, to);
    this.setLoading(false);
  }

  getLoading() {
    return this.loading;
  }
  
  setLoading(value: boolean) {
    this.loading = value;
  }

  getOrderItems() {
    if (this.orderItems.length > 0) {
      return true;
    }
    return false;
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success('BomLineId Copied', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }


showSummary(bomId: string) {
    this.skuDetailLoading = true;
    if(this.selectedBomId && this.selectedBomId == bomId && this.showBomTable){
      this.showBomTable = false;
      this.skuDetailLoading = false;
    }else if(this.selectedBomId && this.selectedBomId == bomId) {
            this.skuDetailLoading = false;
            this.showBomTable = true;
    }else{
      this.showBomTable = false;
      this.selectedBomId = bomId;
      this.projectService.getBomLines(bomId).subscribe(response => {
        this.bomData = response;
        this.bomTableService.toTableBomRowsV2(this.bomData, localStorage.getItem('marketAccountNo'))
          .subscribe(rows => {
            this.bomItems = rows;
            this.skuDetailLoading = false;
            this.showBomTable = true;
          });
      }
      );
    }
  }

  navigateToWorksheet(item: any) {
    if (!(item.isQuoted && item.isQuoted === true) && (item.orderNumber === undefined || item.orderNumber === null)) {
      this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-worksheet', item.id] } }],
        { queryParams: { backToSearch: 'y' } });
    } else if (item.orderNumber === undefined || item.orderNumber === null) {
      this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['checkout', item.id] } }],
      { queryParams: { backToSearch: 'y' } });
    } else {
      let projectOrderInputs = new ProjectOrderInput(item.project.name, this.accountNumber, item.orderNumber, localStorage.getItem("marketLocationCode"))
      this.projectService.getOrderConfirmationV2(projectOrderInputs).subscribe(result => {
        let confirmedOrder = result.orders[0];
        if(confirmedOrder && item.project.name && this.accountNumber) {
          this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-confirmation', item.project.name, this.accountNumber, item.orderNumber] } }],
          { queryParams: { backToSearch: 'y' } });
        } else {
          this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['confirmedOrder', item.id] } }],
          { queryParams: { backToSearch: 'y' } });
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/search/worksheet-result/worksheet-result.component.ts